










import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Services ---
import AuthService from '@/services/auth';

@Component
export default class DummyRouter extends Vue {
  async beforeMount() {
    // router doesn't have global access to all pages
    // using dummy page for routing
    await AuthService.getLoggedInUser();
    const loggedInUser = this.$store.getters['users/loggedInUser'];

    /*
    // if they are not logged in, the api will redirect to Login automatically, so no need to check this
    if (!loggedInUser.loggedIn) {
      this.$router.push( { name: 'Login'} );
    } else
    */
    
    if (!loggedInUser.registered) {
      this.$router.push( { name: 'Register More'} );
    } else if (!loggedInUser.paid) {
      this.$router.push( { name: 'Campaign Code'} ).catch(() => { 
        // https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
        // Using Solution 2.1: Individual suppress errors on each router.push call
        // do nothing
      });
    } else {      
      this.$router.push( { name: 'My Dashboard'} ).catch(() => { 
        // https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
        // Using Solution 2.1: Individual suppress errors on each router.push call
        // do nothing
      });
    }
  }
}
